<template>
  <div></div>
</template>

<script>
// 扫码 -- 副机
export default {
  data() {
    return {};
  },

  mounted() {
    this.link();
  },

  methods: {
    link() {
      const uuid = this.$route.params.uuid;
      fetch(`/lianghui/sendbase/${uuid}`)
        .then((res) => {
          return res.json();
        })
        .then((json) => {
          this.$router.replace(
            `/view-video/${this.$route.params.where}/right/${uuid}`
          );
        });
    },
  },
};
</script>